"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequestCorrLinks = exports.requestCorrContainerTestId = void 0;
const consts_1 = require("../../consts");
const logger_1 = require("../../logger");
const PunchCorrectionStatus_1 = require("../../components/PunchCorrectionStatus");
exports.requestCorrContainerTestId = 'TimecardRequestContainer';
const getRequestCorrLinks = ({ dashboardPath, PTFGSFeatures = {}, isReportAbsenceLatenessEnabled, isAttendanceIngressPointEnabled, isPunchCorrStatusEnabled, isTaskListForNativeEnabled, isTaskListForWebEnabled, isPunchWorkflowForWebEnabled, isPunchWorkflowForNativeEnabled, isReportTravelTimeWorkflowForWebEnabled, isReportTravelTimeWorkflowForNativeEnabled, punchWFFeatureGates, isManageTimeOffAndLeaveEnabled, isViewAttendanceStatusEnabled }, platform) => {
    const isWeb = platform === 'web';
    const isTaskListEnabled = isWeb
        ? isTaskListForWebEnabled
        : isTaskListForNativeEnabled;
    const isPunchWorkflowEnabled = isWeb
        ? isPunchWorkflowForWebEnabled
        : isPunchWorkflowForNativeEnabled;
    const isReportTravelTimeWorkflowEnabled = isWeb
        ? isReportTravelTimeWorkflowForWebEnabled
        : isReportTravelTimeWorkflowForNativeEnabled;
    return [
        {
            label: 'time_and_attendance_Timecard_Request_Correction_Timeoff_Leave',
            eligible: isManageTimeOffAndLeaveEnabled,
            redirectUrl: consts_1.ATOZ_FEATURE_PATH.TIME_OFF,
            metricName: logger_1.METRICS.TIMECARD_REQUEST_CORR_TIME_OFF.COUNT
        },
        {
            label: 'time_and_attendance_Timecard_Request_Correction_Absence',
            eligible: isReportAbsenceLatenessEnabled,
            redirectUrl: consts_1.ATOZ_FEATURE_PATH.ABSENCE,
            metricName: logger_1.METRICS.TIMECARD_REQUEST_CORR_ABSENCE_LATENESS.COUNT
        },
        {
            label: 'time_and_attendance_Timecard_Request_Correction_UPT',
            eligible: isViewAttendanceStatusEnabled && isAttendanceIngressPointEnabled,
            redirectUrl: consts_1.ATOZ_FEATURE_PATH.ATTENDANCE,
            metricName: logger_1.METRICS.TIMECARD_REQUEST_CORR_ATTENDANCE.COUNT
        },
        {
            label: 'time_and_attendance_Timecard_Request_Correction_CorrPunches',
            eligible: isPunchWorkflowEnabled &&
                isPunchWorkflowEligible(punchWFFeatureGates, isWeb),
            redirectUrl: consts_1.ATOZ_FEATURE_PATH.CORRECT_PUNCHES,
            metricName: logger_1.METRICS.TIMECARD_REQUEST_CORR_PUNCHES.COUNT
        },
        {
            label: 'time_and_attendance_Timecard_Request_Report_Travel_Time',
            eligible: isReportTravelTimeWorkflowEnabled,
            redirectUrl: consts_1.ATOZ_FEATURE_PATH.REPORT_TRAVEL_TIME,
            metricName: logger_1.METRICS.TIMECARD_REQUEST_CORR_PUNCHES.COUNT
        },
        {
            label: 'time_and_attendance_Timecard_Request_Correction_PunchCorrectionStatus',
            eligible: isPunchCorrStatusEnabled && !isTaskListEnabled,
            redirectUrl: `${dashboardPath}?${PunchCorrectionStatus_1.ViewPunchCorrectionStatusUrlParam}=true`,
            metricName: logger_1.METRICS.TIMECARD_REQUEST_CORR_PUNCH_CORR.COUNT
        }
    ];
};
exports.getRequestCorrLinks = getRequestCorrLinks;
const isPunchWorkflowEligible = (punchWFFeatureGates, isWeb) => {
    const { isSubmitMissedPunchEnabled, isDeleteDupePunchEnabled, isDeleteMpcaMpcsForWebEnabled, isDeleteMpcaMpcsForNativeEnabled, isPunchEditForWebEnabled, isPunchEditForNativeEnabled } = punchWFFeatureGates;
    return (isSubmitMissedPunchEnabled ||
        isDeleteDupePunchEnabled ||
        (isWeb && (isDeleteMpcaMpcsForWebEnabled || isPunchEditForWebEnabled)) ||
        (!isWeb &&
            (isDeleteMpcaMpcsForNativeEnabled || isPunchEditForNativeEnabled)));
};
